// --------------------------------------------------------------
// Created On: 2021-10-12
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import useReduxDispatch from "src/hooks/useReduxDispatch";
import useReduxSelector from "../../../../hooks/useReduxSelector";
import { setCurrentUser } from "src/redux/features/currentUserSlice";
import styles from "./CompanyListItem.module.scss";

// A single company in a company list.
export default function CompanyListItem(props: Props): Component {
  const currentUser = useReduxSelector((state) => state.currentUser);
  const dispatch = useReduxDispatch();

  // Visit the select company as an admin.
  function visitCompany(companyId: number, companyName: string, isPackager: boolean): void {
    dispatch(
      setCurrentUser({
        userId: currentUser.userId,
        userName: currentUser.userName,
        emailAddress: currentUser.emailAddress,
        originalCompanyId: currentUser.originalCompanyId,
        companyId: companyId,
        companyName: companyName,
        isCompanyHidden: false,
        permissions: currentUser.permissions,
        isPackager: isPackager,
        mfaEnabled: currentUser.mfaEnabled,
      })
    );
  }

  return (
    <div className={`${styles.body} p-2`} onClick={() => visitCompany(props.companyId, props.name, props.isPackager)}>
      {props.name}
    </div>
  );
}

interface Props {
  companyId: number;
  name: string;
  isPackager: boolean;
}
